export default __webpack_public_path__ + "static/media/packaged_heavy_oil_residue.e3e260ff.png";